<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8sDb6E/tc-custom/9781649794772.jpg?1719602153611" alt="This image is the cover for the book A Diamond in the Desert Sands"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Diamond in the Desert Sands
      </h1>
      <p class="bookDescription body article font2">
        <p>Zein, son of Ahmed the Great Sultan at Isfahan, must attend his father’s meetings to be taught the rules of the Sultanate. His college friend, Shefig invited him to a graduation party that would change his life.</p><p>Yasamina, Shefig’s young sister, a beautiful young woman in her time, is lonely and longs for a man to love her. The night of the party, although locked in her chamber, Yasamina ventures out to drop coins in her mother’s white fountain in the jasmine courtyard and ask God for her wish to come true. That night, under the desert stars the two young people meet and fall under the spell of the jasmine fragrance.</p><p>Experience the magic of the desert and follow the couple who met at the fountain where it all began.</p><p><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melek
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-size:14px;font-family:"Times New Roman",serif;'>Melek was educated at Bath College, University of Bath, England. She taught shorthand, keyboarding, and English as a second language at Camden Secretarial College, and English at Bath College for foreign students.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><br></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-size:14px;font-family:"Times New Roman",serif;'>She loves to travel to various countries, meeting people from all walks of life as well as enjoying the beautiful scenery and cultural cuisine.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><br></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-size:14px;font-family:"Times New Roman",serif;'>Her journeys over the years have brought many memories that include instructing swimming in England and instructing belly dancing in Egypt and the USA for healthy living.</span></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><span style="font-size:13px;">&nbsp;</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?661b2140